import React, { useEffect } from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import WhatsAppButton from '../../../components/whatsapp-button/ui/WhatsAppButton';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import SEO from '../../../components/seo/SEO';
import HelpCard from '../../../components/help-card/ui/HelpCard';
import WishlistSection from '../components/ui/WishlistSection';
import { seoData } from '../../../../data/seoData';
import { initializeWishlist } from '../components/script/wishlist-logic';

const WishlistPage: React.FC = () => {
    const { language, t } = useLanguage();

    useEffect(() => {
        
        // Get wishlist translations from Translations.ts
        const translation = t as any;
        const wishlistTranslations = translation.WISHLIST;
        
        if (!wishlistTranslations) {
            return;
        }
        
        // Prepare translations object
        const translations = {
            seeProduct: wishlistTranslations.seeProduct,
            selectProduct: wishlistTranslations.selectProduct,
            inStock: wishlistTranslations.inStock,
            outOfStock: wishlistTranslations.outOfStock,
            brand: wishlistTranslations.brand,
            stockStatus: wishlistTranslations.stockStatus,
            emptyWishlist: wishlistTranslations.emptyTitle,
            emptyWishlistMessage: wishlistTranslations.emptyText,
            browseProducts: wishlistTranslations.emptyButton
        };
        

        // Initialize wishlist with language and translations
        setTimeout(() => {
            initializeWishlist(language, translations);
        }, 100);

        return () => {
            // Cleanup if needed
        };
    }, [language, t]);

    return (
        <>
            <SEO 
                title={seoData.wishlist.title}
                description={seoData.wishlist.description}
                canonical={seoData.wishlist.canonical}
                noindex={true}
            />
        <div className="wishlist-page-wrapper" style={{ marginTop: 0, paddingTop: 0 }}>
            <Navbar />
            <div className="wishlist-page" style={{ marginTop: 0, paddingTop: 0 }}>
            <WishlistSection />
            </div>
            <section className="container">
                <HelpCard />
            </section>
            <Footer />
            <WhatsAppButton />
            <ScrollToTop />
        </div>
        </>
    );
};

export default WishlistPage;

